/// <reference path="./specifyEmployeeBase.section.ts" />

module Meevo.Plugins.Register {
    "use strict";

    export class SpecifyEmployeeSection extends Meevo.Plugins.Register.SpecifyEmployeeBaseSection {
        isTeacherSelection: boolean = false;

        get $scope() { return this.registerContext.$scope; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(registerContext, true, "specifyEmployee", Register.RegisterSectionCatTypeEnum.Sale, RegisterSectionTypeEnum.Employee);

            this.getEmployees();

            this.$scope.$on("employeeChanged", (evt, args) => {
                this.getEmployees();
            });
        }

        getEmployees() {
            return super.getEmployees().then(() => {
                // see if the filter matches the House, if not, do not add
                if (this.registerContext.isHouseEmployeeMatched(this.filter, this.isTeacherSelection ? Model.EmployeeEntityTypeEnum.Teacher : Model.EmployeeEntityTypeEnum.Employee)) {
                    if (this.isTeacherSelection) {
                        this.employees.splice(0, 0, this.registerContext.UnspecifiedEmployee);
                    } else {
                        this.employees.splice(0, 0, this.registerContext.HouseEmployee);
                    }
                }
                this.registerContext.setLoggedInEmployee(this.employees);
            });
        }

        processCriteria(criteria) {
            if (this.isTeacherSelection) {
                criteria.employeeEntityTypeEnum = Model.EmployeeEntityTypeEnum.Teacher;
                criteria.allowSales = undefined;
            }
        }

        add(employee) {
            if (!employee) {
                return;
            }

            if (!this.isTeacherSelection) {
                this.registerContext.selectedEmployee = employee;
            } else {
                this.registerContext.selectedTeacher = employee;
            }

            const originalSaleLines = angular.copy(this.registerContext.sale.saleLines);

            const saleLines = _.clone(this.registerContext.sale.saleLines);
            const sale = _.clone(this.registerContext.sale);
            sale.saleLines = saleLines;

            let isSaleLineAdded = false;
            let isFirst = true;
            _(this.registerContext.tempSaleLines).each((tempSaleLine) => {
                if ((tempSaleLine.saleType === Model.SalesTypeEnum.Service || tempSaleLine.saleType === Model.SalesTypeEnum.Product) &&
                    employee.employeeEntityType === Model.EmployeeEntityTypeEnum.Student &&
                    !this.registerContext.selectedTeacher &&
                    this.registerContext.canViewStudentTeacherModule) {
                    this.isTeacherSelection = true;
                    this.filter = "";
                    this.getEmployees();
                    isFirst = false;
                    return;
                }

                tempSaleLine.employeeId = this.registerContext.selectedEmployee.id;
                tempSaleLine.employee = this.registerContext.selectedEmployee;
                if (this.registerContext.selectedEmployee.employeeEntityType === Model.EmployeeEntityTypeEnum.Student &&
                    this.registerContext.selectedTeacher &&
                    this.registerContext.selectedTeacher.id != Meevo.Guid.empty.toString()) {
                    tempSaleLine.teacher = this.registerContext.selectedTeacher;
                    tempSaleLine.teacherId = this.registerContext.selectedTeacher.id;
                }
                saleLines.push(tempSaleLine);
                isSaleLineAdded = true;
            });

            if (!isSaleLineAdded) {
                return;
            }

            this.registerContext.tempSaleLines = [];
            
            const continueExecution = (reset: boolean = true) => {
                // Only want to reset if recalculateSale was a success since in the case of a validation failure,
                // the reset causes user to have to start over
                if (reset) {
                    this.registerContext.previouslySelectedSection.reset();
                }
                if (this.registerContext.previouslySelectedSection.sectionType === RegisterSectionTypeEnum.ClientAccountPayment && this.registerContext.isCreditMode) {
                    this.registerContext.finishSection();
                    return;
                }

                const isTabletFlow = device.largeTablet();

                if (isTabletFlow) {
                    this.registerContext.selectSection(this.registerContext.previouslySelectedSection.sectionType);
                    return;
                }

                const isMobileFlow = (device.mobile() || (device.tablet() && device.portrait() && !device.largeTablet()));

                if (isMobileFlow) {
                    if (this.registerContext.previouslySelectedSection.sectionType === RegisterSectionTypeEnum.Products) {
                        this.registerContext.selectSection(RegisterSectionTypeEnum.Products)
                    } else {
                        this.registerContext.selectSection(RegisterSectionTypeEnum.Ticket, reset);
                    }
                    return;
                }

                this.registerContext.selectSection(this.registerContext.previouslySelectedSection.sectionType, reset);
            };

            this.registerContext.recalculateSale(false, null, false, sale)
                .then(() => {
                    // #127758: new-membership path — the ClientMembership_TId (item.id) is minted on this
                    // recalc, so this is where a "send form now?" Yes actually fires for a brand-new membership.
                    this.registerContext.sendMembershipFormNowIfPending();
                    this.registerContext.registerDiscountService.showOfferRemovedMessages(sale).finally(() => {
                        continueExecution();
                    });
                })
                .catch(() => {
                    this.registerContext.sale.saleLines = originalSaleLines;
                    continueExecution(false);
                });
        }

        reset() {
            this.isTeacherSelection = false;
            this.getEmployees();
        }
    }

}